'use client'

import { ElectronicsHowSectionModel } from '@marketplace-web/marketing-campaigns/marketing-landing-page-data'

import HowSectionCard from './HowSectionCard'

type Props = { content: ElectronicsHowSectionModel }

const HowSection = ({ content: { title, cards } }: Props) => {
  return (
    <section data-testid="why-section" className="electronics__how-section">
      <h2 className="electronics__how-title">{title}</h2>
      <div className="electronics__how-cards-container">
        {cards.map((card, index) => (
          <HowSectionCard {...card} key={index} index={index} />
        ))}
      </div>
    </section>
  )
}

export default HowSection
